<script>
import RegistroContato from "@/components/widgets/registro-contato";
import appConfig from "@/app.config";
import Detalhe from "../detalhe"

/**
 * Form-element component
 */
export default {
  page: {
    title: "Registros de Contato",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { RegistroContato, Detalhe },
  data() { 
    return {
      carregando: false,
      aluno: JSON.parse(window.localStorage.getItem('aluno')),
      contextos: [],
      contexto: {},
      analiseCurricular: {
      },
      title: "Registros de Contato",
      items: [
        {
          text: "Início",
          href: "/",
        },
        {
          text: "Aluno",
          href: "#",
        },
        {
          text: "Registros de Contato",
          active: true,
        },
      ],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <Detalhe 
                  :aluno="aluno"
                />
          <RegistroContato :aluno="aluno" />
        </div>
      </div>
    </div>
  </Layout>
</template>